import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SessionExpiredDialogComponent } from './components/session-expired-dialog/session-expired-dialog.component';
import { BrokerOrderStatusDialogComponent } from './components/broker-order-status-dialog/broker-order-status-dialog.component';
import { routeFade } from './core/animations/route-animations';

import SuperTokens from 'supertokens-web-js';
import Session from 'supertokens-web-js/recipe/session';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword'
import ThirdParty from 'supertokens-web-js/recipe/thirdparty'
import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,SessionExpiredDialogComponent,BrokerOrderStatusDialogComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [routeFade]
})
export class AppComponent implements OnInit {
  title = 'NeoTrader Genie';

  constructor(private router: Router) {}

  /**
   * Returns a value that changes on every navigation so the route fade
   * trigger re-fires each time a page is switched or a redirect happens.
   */
  get routeState(): string {
    return this.router.url;
  }

  ngOnInit(): void {
  }
}
